import { sendPurchaseEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class LicensePurchaseEventAdapter extends EventAdapter {
  protected intercomEventKey = 'purchase';
  protected amplitudeEventFunction = sendPurchaseEvent;

  constructor(props: {
    legacyLicenseModel: any;
    referrer: string;
    secondaryReferrer?: string;
    paywallFeature?: string;
  }) {
    super();
    const {
      legacyLicenseModel,
      referrer,
      secondaryReferrer = 'none',
      paywallFeature = null,
    } = props;

    try {
      this.eventData = {
        id: legacyLicenseModel.id,
        license_count: legacyLicenseModel.seats,
        years: legacyLicenseModel.years,
        coupon_code: legacyLicenseModel.couponName,
        price: legacyLicenseModel.pricePerSeat,
        referrer: referrer,
        secondary_referrer: secondaryReferrer,
        referrer_paywall_feature: paywallFeature,
        applied_seat_to_self: legacyLicenseModel.applyNow,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
